import * as React from "react";
import Event from "../../../model/event/Event";

interface IComponentProps {
	event: Event
	children: any,
	continuesPrior: boolean
}

type Props = IComponentProps;

class EventWrapper extends React.PureComponent<Props, {}> {

	wrapper: HTMLDivElement;

	render() {
		if (!this.props.continuesPrior) {
			return (
				<div id={this.props.event.id} ref={(wrapper) => this.wrapper = wrapper}>
					{this.props.children}
				</div>
			);
		}
		else {
			return null;
		}
	}
}

export default EventWrapper;